import {Injectable} from '@angular/core';
import {HttpClient,} from "@angular/common/http";
import {Observable} from "rxjs";
import {ContentsHelper} from "../../helpers/contents.helper";
import {NavigationService} from '../navigation/navigation.service';
import {map} from "rxjs/operators";

@Injectable()
export class ListingService
{


    constructor
	(
		private OBJ_http: HttpClient,
		private OBJ_navigation_service: NavigationService,
	)
	{}


	/**
	 * Function > getListingConfig
	 * @param {string} STR_url
	 */
	getListingConfig(STR_url: string): Observable<Object>
	{

		return this.OBJ_http.get(STR_url);

	} // end function getListingConfig


	/**
	 * Function > getHelper
	 * @desc Holt Inhalte aus dem Backend ueber REST-API uznd gibt ihn verpackt in Helper-Klasse zurueck
	 * @params {string} STR_url
	 * @returns {Observable<ContentsHelper>}
	 */
	getHelper(
		STR_route_menu: string,
		STR_route_submenu: string,
		STR_listing_id: string,
		INT_limit = 25,
		INT_skip = 0,
		STR_sort_by = "",
		STR_order = "asc",
		STR_search = "",
		STR_searchfields = "",
		columns_searchfields = "",
		columns_searchvalues = ""
	): Observable<ContentsHelper>
	{
		let STR_url = this.OBJ_navigation_service.getDataEndpointByRoute(STR_route_menu, STR_route_submenu,  STR_listing_id);

		let OBJ_params = this.OBJ_navigation_service.getDataEndpointParamsByRoute(STR_route_menu, STR_route_submenu);

		let OBJ_menuitem_config = this.OBJ_navigation_service.getMenuitemConfigByRoute(STR_route_menu, STR_route_submenu, STR_listing_id);

        // Lege Parameter an
        OBJ_params = OBJ_params.set("skip", INT_skip.toString());

        // Ausnahmefaelle, fuer die Suche (noch) clientseitig durchgefuehrt wird
		if (
			OBJ_menuitem_config._links.values.client_search ||
			["pages", "landingpages", "channels"].indexOf(STR_route_submenu) > -1
		)
		{
			// If Pagination happens on the clientside fetch "all" data
			INT_limit = 1000;
		}
		else
		{
			// sollte Sortierung gewuenscht sein, diese mit uebergeben
			if(STR_sort_by.length > 0)
			{
				OBJ_params = OBJ_params.set("sort_by", STR_sort_by);
				OBJ_params = OBJ_params.set("order", STR_order);
			} // end if

			// sollte suche gewuenscht sein, diese mit uebergeben
			if(columns_searchfields.length > 0) {
				OBJ_params = OBJ_params.set("columns_searchfields", columns_searchfields);
				OBJ_params = OBJ_params.set("columns_searchvalues", columns_searchvalues);
			}

			if(STR_search.length > 0)
			{
				OBJ_params = OBJ_params.set("searchtext", STR_search);
				OBJ_params = OBJ_params.set("searchfields", STR_searchfields);
			} // end if

		} // end if

        OBJ_params = OBJ_params.set("limit", INT_limit.toString());

		return this.OBJ_http.get(STR_url, {
			params: OBJ_params,
			observe: 'response'
		}).pipe(
			map(
				OBJ_response => new ContentsHelper(OBJ_response.body, OBJ_response.headers.get("Content-Type"))
			)
		);

	} // end function > getHelper


}
